export const DEFAULT_PIN_COLOR = '333333';
